import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../../environments/environment';
import * as moment from 'moment';

@Pipe({ name: 'timeFormatPwa' })
export class TimeFormatPwa implements PipeTransform {
  constructor() {
  }

  transform(value): string {
    if (!value) {
      return;
    }

    if (value.length === 0) {
      return;
    }
    if (environment.language === 'nl-NL') {
      const newMoment = moment(value, 'H:mm'); //recognizes 'H:mm' as valid 24 hr format, not 'HH:mm'
      return newMoment.format('HH:mm');
    }


    if (environment.language === 'en-US') {
      const newMoment = moment(value, 'H:mm'); //recognizes 'H:mm' as valid 24 hr format, not 'HH:mm'
      return newMoment.format('LT');
    }

    return value;

  }
}


